<template>
  <div id="embed_video">
    <iframe
      allow="autoplay"
      id="iframe_player"
      scrolling="no"
      v-if="podcast && podcastFound"
      :src="getLinkPodcast"
      frameborder="0"
      webkitallowfullscreen=""
      mozallowfullscreen=""
      allowfullscreen=""
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ComponentVideo from '~/node_modules/component-video/src/components/Componentplay.vue';
import mixin from '../mixins/Mixin';
export default {
  name: 'embedPodcast',
  metaInfo: {
    title: process.env.META_TITLA,
  },
  components: {
    ComponentVideo,
  },
  mixins: [mixin],
  watch: {
    podcastFound(podcastFound) {
      if (!podcastFound) {
        this.$router.push({ name: 'error' });
      }
    },
  },
  data() {
    return {
      link: null,
    };
  },
  computed: {
    ...mapGetters({
      podcast: 'podcast/getPodcast',
      podcastFound: 'podcast/getPodcastFound',
      skinPlayer: 'layouts/getCurrentSkinPlayer',
    }),
    getLinkPodcast() {
      return this.skinPlayer
        ? this.updateQueryStringParameter(this.podcast.link, 'skin', this.skinPlayer)
        : this.podcast.link;
    },
  },
  methods: {
    ...mapActions('podcast', ['getPreviewLinkByToken']),

    getEmbedPodcast(data) {
      this.getPreviewLinkByToken(data);
    },
  },
  created() {
    this.getEmbedPodcast({ token: this.$route.params.token });
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
#embed_video {
  width: calc(100% + 30px);
  height: 100vh;
  overflow: hidden;
  margin: 0 -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/EmbedPodcast.vue